// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2L6NP","notes":"Notes_notes__2hSVe","note":"Notes_note__MAA21","markdown":"Notes_markdown__P9REg"};